__turbopack_context__.v({
  "copy": "FlavorPairings-module-scss-module__Csgcmq__copy",
  "copyContainer": "FlavorPairings-module-scss-module__Csgcmq__copyContainer",
  "image": "FlavorPairings-module-scss-module__Csgcmq__image",
  "inner": "FlavorPairings-module-scss-module__Csgcmq__inner",
  "root": "FlavorPairings-module-scss-module__Csgcmq__root",
  "theme--makers-reserve": "FlavorPairings-module-scss-module__Csgcmq__theme--makers-reserve",
  "unorderedList": "FlavorPairings-module-scss-module__Csgcmq__unorderedList",
});
